import { workgroupService } from '@/services/api/workgroup.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { workgroupModel } from '@/models/api/workgroup.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const WORKGROUP_MODULE = "api/workgroup";

// ACTIONS
export const GET_ALL_WORKGROUP = 'getAllWorkgroup';
export const CREATE_WORKGROUP = 'createWorkgroup';
export const GET_WORKGROUP = 'getWorkgroup';
export const UPDATE_WORKGROUP = 'updateWorkgroup';
export const UPDATE_WORKGROUP_STATUS = 'updateWorkgroupStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_WORKGROUP_SUCCESS = "allWorkgroupSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_WORKGROUP_SUCCESS = "getWorkgroupSuccess";

export const actions = {
    [GET_ALL_WORKGROUP]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        workgroupService
            .getAll(filter)
            .then((result) => {
                commit(ALL_WORKGROUP_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_WORKGROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return workgroupService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_WORKGROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_WORKGROUP]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return workgroupService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_WORKGROUP_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_WORKGROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return workgroupService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_WORKGROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_WORKGROUP_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return workgroupService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_WORKGROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_WORKGROUP_SUCCESS](state, {data}) {
        let workgroupList = data.data || [];
        state.list.data = workgroupList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = workgroupList.map(item => workgroupModel(item));
        }
    },
    [GET_WORKGROUP_SUCCESS](state, data) {
        state.details = workgroupModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
